export default __webpack_public_path__ + "static/media/vr-truck-circle-orange.ca455fca.svg";